export enum EAppStep {
    TEMPLATES = 'templates',
    EDITION = 'edition',
    PREVIEW = 'preview',
}
